module.exports = "<img width=\"250\" src=\"/assets/images/OsteopathieWeinstrasse_Zug.svg\" alt=\"\">\n"